// extracted by mini-css-extract-plugin
export default {"menu_box":"index_menu_box_Pv-CL","menu":"index_menu_Z-DXe","logo":"index_logo_4Q7-m","list":"index_list_cgrDV"};